import React, { useEffect } from "react";
// Librerías
import styled from "styled-components";
import { motion } from "framer-motion";
// Componentes
import Titulo from "../components/sobre-nosotros/titulo";
import Texto from "../components/sobre-nosotros/texto";
import { useSEO } from "../hooks/useSEO";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--blanco);

  // Motion Div
  .motion-div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
  }
`;

export default function SobreNosotrosPage() {
  // SEO
  useSEO({
    title: "Sobre nosotros",
    description:
      "Conocé a SeguroWeb: la plataforma para cotizar y contratar seguros online en Argentina con más de 30 años de trayectoria y asesoría personalizada.",
    path: "/sobre-nosotros",
  });

  // Scroll ni bien carga la página
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <Container>
      <motion.div
        className="motion-div"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 1, transition: { duration: 0.3 } }}
      >
        {/* Título */}
        <Titulo></Titulo>
        {/* Texto */}
        <Texto></Texto>
      </motion.div>
    </Container>
  );
}
